import { EnterPassword } from '@piconetworks/login'
import withInjection from '@piconetworks/with-injection'

import Account from 'common/modules/account'
import Auth from 'common/modules/auth'
import Loader from 'common/modules/loader'
import Wizard from 'common/modules/wizard'

import WizardRedux, { WizardLoading, WizardError } from 'common/pkgs/WizardRedux'

const mapStateToProps = (state, props) => {
    const { router } = props

    const thisWizard = Wizard.selectors.thisWizard({ state, router })

    return {
        ...props,
        authError: state.auth.error,
        loader: Loader.selectors.loader(state),
        publisherId: state.loader.guest.publisher.id,
        scope: state.loader.user ? 'user' : 'guest',
        getScopedLoader: (scope) => Loader.selectors.scopedLoader(state, scope),
        thisWizard,
        utmRootUrl: process.env.MARKETING_SITE_URL,
        WizardRedux,
        WizardLoading,
        WizardError,
        renderBackButton: true,
        onBackButtonClick: () => {
            router.push({
                pathname: '/login/enter-email',
                query: {
                    ...(thisWizard?.id && { id: thisWizard.id }),
                },
            })
        },
        queryOverride: {
            utmCampaign: state?.zoid?.tag,
            utmSource: Loader.selectors.publisherName(state),
            utmMedium: process.env.HOSTNAME,
            utmContent: 'EnterPassword',
            rootUrl: process.env.MARKETING_SITE_URL,
        },
        loginEmail: Account.selectors.loginEmail(state),
    }
}

const mapDispatchToProps = {
    login: Auth.creators.login,
    initialize: Auth.creators.initialize,
    resetLogin: Account.creators.setLoginEmail,
}

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,

    onBackButtonClick: () => {
        dispatchProps.initialize()
        stateProps.onBackButtonClick()
        dispatchProps.resetLogin()
    },
})

const InjectedEnterPassword = withInjection(EnterPassword, {
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
})

export default InjectedEnterPassword
